module.exports = {
	"message": {
		"cs-CZ": "Jelikož jsou již první tři alba vyprodána, rozhodli jsme se je celá umístit na naše webové stránky. Alba si můžete buď přímo poslechnout, nebo stáhnout (odkazy uvedeny níže).",
		"en-GB": "Since the first three albums are sold out, we have decided to put them on the web. You can either listen to or download the mp3 files (see links below). You can also listen to samples of the albums that are still available.",
		"fr-FR": "Comme les trois premiers albums sont épuisés, nous avons décidé de les mettre sur le web. Vous pouvez soit les écouter, soit les télécharger (voir les liens ci-dessous). Vous pouvez également écouter des extraits des albums qui sont encore disponibles.",
		"de-DE": "Da die ersten drei Alben ausverkauft sind, haben wir beschlossen, sie ins Internet zu stellen. Sie können die mp3-Dateien entweder anhören oder herunterladen (siehe Links unten). Sie können sich auch Hörproben der noch verfügbaren Alben anhören."
	},
	"year": {
		"cs-CZ": "natočeno r.",
		"en-GB": "recorded in",
		"fr-FR": "enregistré en",
		"de-DE": "aufgenommen"
	},
	"sold": {
		"cs-CZ": "vyprodané",
		"en-GB": "sold out",
		"fr-FR": "épuisé",
		"de-DE": "ausverkauft"
	},
	"mp3List": {
		"cs-CZ": "(mp3 ukázky z alba)",
		"en-GB": "(mp3 samples of the album)",
		"fr-FR": "(des extraits mp3 de l'album)",
		"de-DE": "(mp3-Beispiele des Albums)"
	},
	"mp3ListFull": {
		"cs-CZ": "(celé album v mp3)",
		"en-GB": "(full album in mp3)",
		"fr-FR": "(album complet en mp3)",
		"de-DE": "(ganzes Album im mp3-Format)"
	},
	"download": {
		"cs-CZ": "celé album ke stažení:",
		"en-GB": "full album for download:",
		"fr-FR": "album complet à télécharger :",
		"de-DE": "vollständiges Album zum Herunterladen:"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Discography/Discography.json
// module id = 14
// module chunks = 0